// extracted by mini-css-extract-plugin
export var message = "Messages-module--message--35jrY";
export var welcomeMessage = "Messages-module--welcomeMessage--2k5fG";
export var welcomeLink = "Messages-module--welcomeLink--2qj9K";
export var aboutMessage = "Messages-module--aboutMessage--LfBZi";
export var link = "Messages-module--link--21MZV";
export var fadeIn = "Messages-module--fadeIn--39ib_";
export var slideIn = "Messages-module--slideIn--1zV_o";
export var bgGradient = "Messages-module--bgGradient--1TC2p";
export var borderColorStep = "Messages-module--borderColorStep--3P4BQ";